import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AngularFileUploadComponent } from './angular-file-upload/angular-file-upload.component';
import { PesaFlowSuccessComponent } from './pesa-flow-success/pesa-flow-success.component';


const routes: Routes = [
  {
    path: 'post-check',
    component:AngularFileUploadComponent
  },
  {
    path: 'admin',
    loadChildren: () => import('./sub-admin/sub-admin.module').then(mod => mod.SubAdminModule)
  },
  {
    path: 'institute',
    loadChildren: () => import('./institute-sprint/institute-sprint.module').then(mod => mod.InstituteSprintModule)
  },
  {
    path: 'foreign-institute',
    loadChildren: () => import('./institute-sprint/foriegn-institute-sprint.module').then(mod => mod.ForeignInstituteSprintModule)
  },
  {
    path: 'auth',
    loadChildren: () => import('./common-module/common-module.module').then(mod => mod.CommonModuleModule)
  },
  {
    path: 'curriculum',
    loadChildren: () => import('./curriculum-developer/curriculum-developer.module').then(mod => mod.CurriculumDeveloperModule)
  },

{
  path: '',
  loadChildren: () => import('./landing/landing.module').then(mod => mod.LandingModule)
},
{
  path: 'assessors',
  loadChildren: () => import('./trainer/trainer.module').then(mod => mod.TrainerModule)
},

// {
//   path: 'pesa_flow_success',
//   component : PesaFlowSuccessComponent
// },

];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
